import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WalletService } from '@service/wallet.service';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-coupon-reward',
  templateUrl: './coupon-reward.component.html',
  styles: [
  ]
})
export class CouponRewardComponent implements OnInit {

  vpa = new FormControl('', Validators.compose([
    Validators.required,
    Validators.pattern(new RegExp('[a-zA-Z0-9\.\-]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}'))
  ]));
  name = new FormControl('', Validators.required);
  currentUser: any;
  disableBtn: boolean = false;
  
  constructor(
    private dialogRef: MatDialogRef<CouponRewardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private benefitsService: WalletService,
    private authService: AuthService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.authService.userProfile.subscribe((res)=> {
      this.currentUser = res
      if(this.currentUser.name){
        this.name.patchValue(this.currentUser.name)
      }
    })
  }

  closeDialog(){
    this.dialogRef.close()
  }

  upiDetail(id) {
    const data = {
      name: this.name.value.replace(/\s+/g, ' ').trim(),
      vpa: this.vpa.value.trim()
    }
    this.benefitsService.rewardToBank(data).subscribe(
      (res) => {
        this.authService.UpdateUserData(false);
        this.currentUser.isEditVpa = false;
        this.transferPayout(id)
      },
      (err: any) => {
        this.disableBtn = false
        this.currentUser.isEditVpa = false;
      }
    )
  }

  transferPayout(id) {
    let data = {
      rewardId : id
    }
    this.benefitsService.transferPayout(data)
    .pipe(finalize(() => (this.closeDialog(), this.disableBtn = false)))
    .subscribe(
      (res) => {
        this.alertService.success(res.message);
      }
    )
  }

  claimReward(id){
    this.disableBtn = true
    if(this.currentUser.name && this.currentUser.razorpay && this.currentUser.razorpay.fundAccountVPA){
      this.transferPayout(id)
    }  else {
      this.upiDetail(id)
    }
  }
}
